// extracted by mini-css-extract-plugin
module.exports = {"Reason":"Reason_Reason__uMqu9"};